export const c_chip__text_MaxWidth = {
  "name": "--pf-v5-c-chip__text--MaxWidth",
  "value": "16ch",
  "var": "var(--pf-v5-c-chip__text--MaxWidth)"
};
export default c_chip__text_MaxWidth;